import { cn } from "@/lib/utils"

/**
 * One labelled money figure on the till screen.
 *
 * Every number here can change between renders, so every one of them is
 * `tabular-nums`: a column of amounts whose digits shift sideways is a column
 * nobody can scan. Colour never lands on the figure itself — the design
 * system's dot rule puts state in a small mark beside the label, which is why
 * this primitive has no tone variant.
 */
export function TillFigure({
  label,
  value,
  hint,
  testId,
  emphasis = false,
}: {
  label: string
  value: string
  hint?: string
  testId?: string
  emphasis?: boolean
}) {
  return (
    <div className="space-y-1">
      <p className="text-xs text-muted-foreground">{label}</p>
      <p
        data-testid={testId}
        className={cn(
          "font-semibold tabular-nums text-foreground",
          emphasis ? "text-lg" : "text-sm"
        )}
      >
        {value}
      </p>
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  )
}
